import React from 'react';

import Loader from '@components/Loader/Loader';
import general from '@assets/gifs/general.json';

const GeneralLoader = ({ shouldScroll = true }: { shouldScroll?: boolean }) => {
  return <Loader loaderType={general} shouldScroll={shouldScroll} />;
};

export default GeneralLoader;
